import LazyChartControllerBase from './helpers/lazy_chart_controller_base';
import Chart from 'chart.js/auto';

export default class extends LazyChartControllerBase {
  static values = { inputs: String };
  static targets = ['chartcanvas'];

  _buildChart() {
    const chartData = JSON.parse(this.inputsValue);
    const chartOptions = {
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              return Math.round(context.raw * 100) + '%';
            },
          },
        },
      },
      barPercentage: 0.9,
      categoryPercentage: 0.8,
      elements: {
        bar: {
          borderRadius: 5,
        },
      },
      scales: {
        y: {
          grace: '0',
          display: true,
          grid: {
            display: true,
            lineWidth: (context) => (context.tick.value == 0 ? 1 : 0), //Set only 0 line visible
          },
          ticks: {
            maxTicksLimit: 3,
            format: {
              style: 'percent',
            },
          },
        },
        x: {
          ticks: {
            color: '#808191',
          },
          border: {
            display: false,
          },
        },
      },
    };

    new Chart(this.chartcanvasTarget, {
      type: 'bar',
      data: chartData,
      options: chartOptions,
    });
  }
}
